import { type FC, type ReactNode } from "react";

import { css } from "@emotion/css";
import { GraphikFont } from "@snapchat/snap-design-system";

import { Flexbox } from "../../shared/components";

const container = css`
    position: relative;
    overflow-x: hidden;
    min-height: 100vh;
    background: #f9f9f9;
`;

export const Layout: FC<{ children?: ReactNode }> = ({ children }) => (
    <Flexbox flexDirection="column" className={container}>
        <GraphikFont />
        {children}
    </Flexbox>
);
